import React, { useState } from "react";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import refreshIcon from "../../assets/refresh.png";
import { BsInfoCircle, BsCashCoin } from "react-icons/bs";
import deleteLogo from "../../assets/delete.png";
import ResponsiveTable from "../Common/Table/ResponsiveTable";
import CollapseButton from "../Common/CollapseButton";

const OrderSummary = ({
  refreshPaymentStatus,
  isShowPayButton,
  collectPayment,
  setPayModal,
  orderSummary,
  orderSummaryTableData,
  childOrderTableData,
  showEnterPaymentModal,
  childOrderProductsTableData, isReadOnly,
}) => {
  const renderOrderSummary = () => {
    return (
      <>
        <Card.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span>Booking overall order/payment Summary</span>
          </div>
          <ResponsiveTable headers={orderSummaryTableData().headers} rows={orderSummaryTableData().rows}></ResponsiveTable>
          <CollapseButton expandLabel={"Show all orders/payments"} collapeLabel={"Hide all orders/payments"}>
            {orderSummary?.orders &&
              orderSummary.orders.map((ord, index) => (
                <>
                  <Card.Body>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <span>Store Orders Detail</span>
                    </div>
                    <ResponsiveTable headers={childOrderTableData(ord).headers} rows={childOrderTableData(ord).rows}></ResponsiveTable>
                  </Card.Body>

                  {/*product table*/}
                  <CollapseButton expandLabel={"Show products in this order"} collapeLabel={"Hide products in this order"}>
                    <Card.Body>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <span>Order product detail</span>
                      </div>
                      {ord?.products && (
                        <>
                          <ResponsiveTable
                            headers={childOrderProductsTableData(ord?.products).headers}
                            rows={childOrderProductsTableData(ord?.products).rows}
                          ></ResponsiveTable>
                        </>
                      )}
                    </Card.Body>
                  </CollapseButton>
                </>
              ))}
          </CollapseButton>
        </Card.Body>
      </>
    );
  };

  return (
    <Accordion defaultExpanded className="mb-4 rounded-none">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header className="w-100 border-0 bg-transparent ">
          <Row id="cardTitle">
            <Col md={4}>
              Order Summary Section
              <OverlayTrigger
                placement="right"
                delay={{ show: 50, hide: 400 }}
                overlay={
                  <Tooltip
                    style={{
                      background: "black",
                      color: "white",
                      marginLeft: 5,
                      borderRadius: 5
                    }}
                  >
                    Read-only - Displays customer's payment & order information just for this booking.
                    <br />
                    Also reconiles above planned products vs. actual payment & provides overall payment status & pending un-paid amount.
                  </Tooltip>
                }
              >
                <BsInfoCircle />
              </OverlayTrigger>
            </Col>
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <Row className="mr-1">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <span>Refresh Order Summary </span>&nbsp;&nbsp;
                  <img
                    id="refreshOrderIcon"
                    alt="refresh"
                    src={refreshIcon}
                    style={{
                      width: "2vw",
                      height: "2vw",
                      objectFit: "contain",
                      cursor: "pointer",
                      transitionDuration: "1s"
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      refreshPaymentStatus();
                    }}
                  />
                </div>
                {isShowPayButton() && (
                  <Button
                      disabled={isReadOnly}
                    variant="light"
                    style={{ background: "#866BD9", color: "white" }}
                    onClick={e => {
                      e.stopPropagation();
                      setPayModal(true);
                    }}
                  >
                    <BsCashCoin>
                      <span>{orderSummary?.netTotalUnpaid}</span>
                    </BsCashCoin>
                    &nbsp;&nbsp;
                    <span id="btn-text">Send Payment Link</span>
                  </Button>
                )}
                {isShowPayButton() && (
                  <Button disabled={isReadOnly} variant="light" style={{ background: "#866BD9", color: "white" }} onClick={() => collectPayment()}>
                    <BsCashCoin>
                      <span>{orderSummary?.netTotalUnpaid}</span>
                    </BsCashCoin>
                    &nbsp;&nbsp;
                    <span id="btn-text">Collect Payment</span>
                  </Button>
                )}
                <Button variant="light" style={{ background: "#866BD9", color: "white" }} onClick={() => showEnterPaymentModal()}>
                  <BsCashCoin>
                    <span>{orderSummary?.netTotalUnpaid}</span>
                  </BsCashCoin>
                  &nbsp;&nbsp;
                  <span id="btn-text">Enter Payment Info</span>
                </Button>
              </Row>
            </Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails className="accordionDetails">
        <Row className="w-100">
          <Col className="">
            <Card className="Card-wrap-2 border-0 shadow-none">
              <Card.Body>{renderOrderSummary()}</Card.Body>
            </Card>
          </Col>
        </Row>
      </AccordionDetails>
    </Accordion>
  );
};

export default OrderSummary;
